exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chartist-tooltip-wrap\n{\n    position: relative;\n}\n\n.chartist-tooltip\n{\n    font-size: 12px;\n    font-weight: 400;\n\n    position: absolute;\n    z-index: 1; \n\n    display: inline-block;\n\n    padding: 3px 8px;\n\n    text-align: center;\n    text-align: center;\n    pointer-events: none;\n\n    color: #fff;\n    border-radius: 3px;\n    background-color: rgba(0, 0, 0, .7);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /app/~/css-loader?{"sourceMap":false,"importLoaders":1}!/app/~/postcss-loader?{"ident":"postcss"}!/app/src/vendor/chartist-plugin-tooltip/chartist-plugin-tooltip.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/vendor/chartist-plugin-tooltip/chartist-plugin-tooltip.css
// module chunks = 5